var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEditGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1809 6.58465C28.4014 5.80512 27.1375 5.80512 26.358 6.58465L6.29233 26.6503C6.10011 26.8425 5.99461 27.1048 6.00021 27.3766L6.11422 32.9085C6.12525 33.4436 6.5564 33.8747 7.09151 33.8858L12.6234 33.9998C12.8952 34.0054 13.1575 33.8999 13.3497 33.7077L33.4153 13.642C34.1949 12.8625 34.1949 11.5986 33.4153 10.8191L29.1809 6.58465ZM9.01129 28.1658L9.0683 30.9317L11.8342 30.9887L14.2394 28.5835L11.4165 25.7606L9.01129 28.1658Z",
    fill: "#364356"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditGrey);
export default __webpack_public_path__ + "static/media/iconEditGrey.5117d05c.svg";
export { ForwardRef as ReactComponent };